import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";

export default function OrderAdjustmentsModal({ onClose, onAddItems, onReturnItems }) {
  return (
    <Dialog open fullWidth maxWidth="xs" onClose={onClose}>
      <DialogTitle sx={{ pr: 6, color: "#000" }}>
        <Typography align="center" color="#000" fontSize={20} fontWeight={500}>
          Edit Order Items
        </Typography>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Alert severity="warning" icon={false} sx={{ mb: 2 }}>
          For customer order changes only. Picked items need a verified return location before
          returning to stock.
        </Alert>
        <Box display="flex" flexDirection="column" gap={1}>
          <Button variant="outlined" onClick={onAddItems}>
            Add Items
          </Button>
          <Button variant="outlined" onClick={onReturnItems}>
            Return Items
          </Button>
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
}
